export default "__VITE_ASSET__CaC6di_Y__"